const setOpacity = (hex, alpha) =>
	`${hex}${Math.floor(alpha * 255)
		.toString(16)
		.padStart(2, 0)}`;

// one function to easy change the amount of opacity added for every menu
const addOpacityMenu = colorStr => {
	return setOpacity(colorStr, 0.65); //antd menu default is 0.65
};

// remove the opacity part of an rgba Array String
const removeOpacityMenu = rgbaArrayStr => {
	let rgbaArray = rgbaArrayStr.split(",");
	if (rgbaArray.length === 4) {
		rgbaArray = rgbaArray.slice(0, -1);
		return rgbaArray.join(",") + ")";
	}
	return rgbaArrayStr;
};

const getMoogoColor = typeStr => {
	try {
		switch (typeStr.toLowerCase()) {
			case "auftrag": {
				return "blue";
			}
			case "order": {
				return "blue";
			}
			case "product": {
				return "volcano";
			}
			case "produkt": {
				return "volcano";
			}
			case "resource": {
				return "green";
			}
			case "ressource": {
				return "green";
			}
			case "action": {
				return "gold";
			}
			case "process": {
				return "gold";
			}
			case "prozess": {
				return "gold";
			}
			default: {
				return "#000";
			}
		}
	} catch (error) {
		return "#000";
	}
};

export { addOpacityMenu, removeOpacityMenu, getMoogoColor };
